export default {
  data () {
    return {
      emailLoading: false
    };
  },
  methods: {
    checkEmail (email, id) {
      this.emailLoading = true;
      this.axios.get('/users/check', {params: {email: email, id: id}}).then(() => {
        this.emailLoading = false;
        this.$validator.errors.remove('email');
      }).catch(err => {
        this.$errorOut(err);
        this.$validator.errors.add({
          field: 'email',
          msg: err.response.data.message
        });
      });
    }
  }
};